<template>
  <div style="display: flex">
    <div class="header-menu" v-loading.fullscreen.lock="loading">
      <div style="margin:0 auto">
        <div style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
          <div style="display: flex;align-items: center;">
            <h1 style="color: #409EFF;text-decoration:none">{{ $t('HangKnife') }}</h1>
            <el-menu
              :default-active="activeRouter"
              router
              class="el-menu-demo"
              mode="horizontal"
            >
              <el-menu-item index="/Home">{{ $t('Home') }}</el-menu-item>
              <el-menu-item index="/TradeUp">{{ $t('Trade Up') }}</el-menu-item>
              <el-menu-item index="/Tools">实用工具</el-menu-item>
            </el-menu>
          </div>
          <div style="display: flex;align-items: center;gap: 12px;">
            <!-- 搜索框 -->
            <div style="display: flex;align-items: center;">
              <el-autocomplete
                size="small"
                :trigger-on-focus="false"
                v-model="searchKeyword"
                :fetch-suggestions="remoteSearch"
                :placeholder="$t('pleaseInput')"
                @keydown.native="onSearchKeyDown"
                @select="handleSearchSelect"
                style="width: 280px;"
                clearable
                popper-class="search-autocomplete-popper"
              >
                <template slot-scope="{ item }">
                  <div style="display: flex;align-items: center;justify-content: space-between;padding: 6px 0;width: 100%;">
                    <div style="display: flex;flex-direction: column;flex: 1;min-width: 0;">
                      <span style="font-weight: 500;font-size: 14px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                        {{ item.cnName || item.name }}
                      </span>
                      <span style="font-size: 12px;color: #909399;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                        {{ item.engName || item.enName || '' }}
                      </span>
                    </div>
                    <span
                      class="rarity-tag"
                      :style="getRarityStyle(item.rarityName || item.rarity)"
                    >
                      {{ item.rarityName || item.rarity || '' }}
                    </span>
                  </div>
                </template>
              </el-autocomplete>
            </div>

            <el-select v-model="language" style="width: 155px" @change="changeLanguage" size="small">
              <el-option :key="'zh'" label="中文" value="zh">
                <div class="DropdownElement" style="min-height:38px" id="zh">
                  <img src="static/imgs/zh.svg" style="height: 20px;width: 20px;vertical-align: -12%;margin-right: 12px" alt="zh">中文
                </div>
              </el-option>
              <el-option :key="'en'" label="English" value="en">
                <div class="DropdownElement" style="min-height:38px" id="zh">
                  <img src="static/imgs/en.svg" style="height: 20px;width: 20px;vertical-align: -12%;margin-right: 12px"
                       alt="zh">English
                </div>
              </el-option>
            </el-select>
            <el-select v-model="currency" @change="changeCurrency"
                       style="color: #fcf5e8;font-size: .875rem;font-weight: 700;width: 95px" size="small">
              <el-option :key="'CNY'" label="CNY" value="CNY" id="CNY">
              </el-option>
              <el-option :key="'USD'" label="USD" value="USD" id="USD">
              </el-option>
              <el-option :key="'AUD'" label="AUD" value="AUD" id="AUD">
              </el-option>
              <el-option :key="'EUR'" label="EUR" value="EUR" id="EUR">
              </el-option>
              <el-option :key="'RUB'" label="RUB" value="RUB" id="RUB">
              </el-option>
              <el-option :key="'TRY'" label="TRY" value="TRY" id="TRY">
              </el-option>
              <el-option :key="'JPY'" label="JPY" value="JPY" id="JPY">
              </el-option>
              <el-option :key="'HKD'" label="HKD" value="HKD" id="HKD">
              </el-option>
              <el-option :key="'CAD'" label="CAD" value="CAD" id="CAD">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  allCurrencyOptions,
  logOff,
  remoteSearchOptions
} from "../../api/api";
import store from "../../store";
import i18n from "../../main";
import {cloneObj} from "../../api/util";

const {loginSteamCommunityConfirm} = require("../../api/api");

export default {
  name: "menuBar",
  data() {
    return {
      activeRouter: 'Home',
      loading: false,
      language: this.$i18n.locale,
      currency: localStorage.getItem("selectedCurrency"),
      searchKeyword: '',
      searchResults: [],
    }
  },
  computed: {
    login() {
      let steamId = this.$store.getters.getUserInfo.steamId
      if (steamId) {
        return true
      } else {
        return false
      }
    },
    userInfo() {
      return this.$store.state.userInfo;
    }
  },
  methods: {
    // 获取稀有度样式
    getRarityStyle(rarity) {
      const styles = {
        '消费级': 'color: #b0c3d9;',
        '军规级': 'color: #4b69ff;',
        '受限': 'color: #8847ff;',
        '保密': 'color: #d32ce6;',
        '隐秘': 'color: #eb4b4b;',
        '违禁': 'color: #e4ae39;',
        '非凡': 'color: #eb4b4b;',
        '卓越': 'color: #8847ff;',
        '奇异': 'color: #d32ce6;',
        '高级': 'color: #4b69ff;',
        '普通级': 'color: #b0c3d9;',
        '不朽': 'color: #F2B166;',
        '至宝': 'color: #9ACC4C;',
        '神话': 'color: #A876F9;',
        '珍稀': 'color: #7C8FF5;',
        '罕见': 'color: #82BDFF;',
        'Classified': 'color: #d32ce6;',
        'Mil-Spec': 'color: #4b69ff;',
        'Restricted': 'color: #8847ff;',
        'Covert': 'color: #eb4b4b;',
        'Consumer': 'color: #b0c3d9;',
        'Industrial': 'color: #5e98d9;',
        'Contraband': 'color: #e4ae39;',
        'Legendary': 'color: #A876F9;',
        'Mythical': 'color: #8847ff;',
        'Immortal': 'color: #F2B166;',
        'Arcana': 'color: #9ACC4C;',
        'Ancient': 'color: #eb4b4b;',
      };
      return styles[rarity] || '';
    },

    // 远程搜索方法
    remoteSearch(queryString, cb) {
      if (!queryString || queryString.trim().length === 0) {
        cb([]);
        return;
      }

      remoteSearchOptions({name: queryString , game :'csgo'}).then(json => {
        if (json.data && json.data.length > 0) {
          const results = json.data.map(item => ({
            ...item,
            value: item.cnName || item.name,
            rarityName: item.rarityName || item.rarity || '',
            engName: item.engName || item.enName || ''
          }));
          cb(results);
        } else {
          cb([]);
        }
      }).catch(() => {
        cb([]);
      });
    },

    // 键盘事件 - 回车触发搜索跳转
    onSearchKeyDown(event) {
      if (event.key === 'Enter' && this.searchKeyword.trim()) {
        this.navigateToItemPage(this.searchKeyword.trim());
      }
    },

    // 选择下拉选项时触发
    handleSearchSelect(item) {
      this.$router.push({
        path: '/ItemPage',
        query: {marketHashName: item.engName}
      });
      // 清空搜索框
      this.searchKeyword = '';
    },

    // 导航到物品详情页
    navigateToItemPage(searchText) {
      // 先尝试通过名称搜索获取物品ID
      remoteSearchOptions({name: searchText , game: 'csgo'}).then(json => {
        if (json.data && json.data.length > 0) {
          const item = json.data[0];
          this.$router.push({
            path: '/ItemPage',
            query: {marketHashName: item.engName}
          });
          // 清空搜索框
          this.searchKeyword = '';
        } else {
          // 如果没有找到匹配的物品，提示用户
          this.$message({
            message: this.$t('itemNotFound') || '未找到该物品',
            type: 'warning'
          });
        }
      }).catch(() => {
        this.$message({
          message: this.$t('searchFailed') || '搜索失败，请稍后重试',
          type: 'error'
        });
      });
    },

    loginViaSteam() {
      let loginUrl = 'http://www.hangKnife.com/oauthNode'
      let steamLoginUrl = `https://steamcommunity.com/openid/login?openid.mode=checkid_setup&openid.claimed_id=http://specs.openid.net/auth/2.0/identifier_select&openid.identity=http://specs.openid.net/auth/2.0/identifier_select&openid.ns=http://specs.openid.net/auth/2.0&openid.realm=${loginUrl}&openid.return_to=${loginUrl}/steam/oauthCallback`
      window.open(steamLoginUrl, '_parent', 'width=650,height=700,top=25,left=50')
    },
    getSteamBalance() {
      return this.$store.getters.getUserInfo.wallet == null ? 0 : this.$store.getters.getUserInfo.wallet.balance
    },
    handleCommand(val) {
      switch (val) {
        case 'account':
          this.$router.push('/Account')
          break;
        case 'logOut':
          logOff({}).then(json => {
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('authCode')
            localStorage.removeItem("steamId")
            localStorage.removeItem("session")
            localStorage.removeItem("cookies")

            store.commit('clearUserInfo');
            store.commit('setLogin', false)
            this.loginStatus = 'Logining....'
            this.$message({
              message: '注销成功',
              type: 'success'
            });
          })
          break;
        default:
          return;
      }
    },
    changeLanguage(language) {
      this.$i18n.locale = language;
      localStorage.setItem('selectedLanguage', language);
    },
    changeCurrency(currency) {
      store.commit('setCurrency', currency);
      localStorage.setItem("selectedCurrency", currency);
    },
  },
  created() {
    this.activeRouter = this.$route.path
    allCurrencyOptions().then(json => {
      let options = cloneObj(json.data.data)
      options.CNY = "1"
      this.$store.commit('setCurrencyOptions', options)
    })
  }
}
</script>

<style scoped>

.header-menu {
  flex: 1;
  text-align: center;
  position: relative;
  height: 60px;
  width: 100%;
  min-width: 1200px;
  border-bottom: 1px solid #dcdfe6;
}

.header-menu h1 {
  font-size: 26px;
  color: #409EFF;
  font-weight: 400;
  margin: 0px;
  padding: 12px 0px;
  min-width: 210px;
}

.routerLink a {
  text-decoration: none
}

.drop-store {
  width: 238px;
  min-height: 160px;
  background: #3a4452;
  border: 1px solid #282F39;
  box-shadow: 0 5px 10px 0 rgb(0 0 0 / 20%);
  border-radius: 2px;
  line-height: 1em !important;
  z-index: 104;
}

.store-user {
  padding: 20px;
  background: #313a45;
  font-size: 0;
}

.user-title {
  float: right;
  height: 42px;
  width: 60%;
  padding: 5px;
  color: #E4E8EE;
  vertical-align: middle;
  max-width: 122px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.userTriggerTittle {
  float: right;
  position: relative;
  line-height: 46px;
  display: flex;
}

.userTriggerTittle:hover {
  cursor: pointer;
}

.routerTab {
  font-weight: 400;
  display: inline-block;
  cursor: pointer;
}


iframe {
  border: none;
  margin: 0;
  padding: 0;
}

.userAvatar {
  display: flex;
  align-items: center;
}

.userAvatar:hover {
  cursor: pointer;
}

.avatarDiv {
  margin-right: 12px;
  min-width: 280px;
  line-height: 19px;
  align-items: center;
  display: flex;
}

.login-other {
  font-size: 12px;
  color: #959595;
  text-align: center;
  background: #f0f0f0;
  padding: 10px 0;
  position: relative;
  z-index: 99;
  border-radius: 12px;
}

/* 搜索框样式优化 */
.el-autocomplete {
  min-width: 200px;
}

.el-autocomplete .el-input__inner {
  border-radius: 20px;
  padding-left: 16px;
}

.rarity-tag {
  font-size: 12px;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 12px;
  background-color: rgba(0, 0, 0, 0.06);
  white-space: nowrap;
  flex-shrink: 0;
  margin-left: 12px;
  letter-spacing: 0.5px;
}

</style>

<style>
/* 全局样式 - 搜索下拉框 */
.search-autocomplete-popper {
  min-width: 300px !important;
}

.search-autocomplete-popper .el-autocomplete-suggestion__list {
  padding: 4px 0;
}

.search-autocomplete-popper .el-autocomplete-suggestion__item {
  padding: 8px 16px !important;
  border-bottom: 1px solid #f0f2f5;
}

.search-autocomplete-popper .el-autocomplete-suggestion__item:last-child {
  border-bottom: none;
}

.search-autocomplete-popper .el-autocomplete-suggestion__item:hover {
  background-color: #f5f7fa !important;
}

.search-autocomplete-popper .el-autocomplete-suggestion__item.highlighted {
  background-color: #ecf5ff !important;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}

.loginDialog {
  padding: 0px;
  border-radius: 12px;
}

.loginDialog .el-dialog__body {
  padding: 0px !important;
}

.loginDialog .el-dialog__header {
  display: none;
}

.userPopper[x-placement^='left'] .popper__arrow::after {
}

.userPopper[x-placement^='right'] .popper__arrow::after {
}

.userPopper[x-placement^='bottom'] .popper__arrow::after {
}

.userPopper[x-placement^='top'] .popper__arrow::after {
}

.userPopper .el-popover__title {
}

.userPopper {
  font-size: 18px;
  padding: 0px;
  background: none;
}

.el-menu-demo {
  min-width: 170px;
}

.DropdownElement {
  display: flex;
  align-items: center;
  min-height: 30px;
  padding: 0 10px;
  font-size: 14px;
  line-height: 100%;
  white-space: nowrap;
  cursor: pointer;
  border-radius: 2px;
  transition: all .2s cubic-bezier(.4, 0, .2, 1);
}
</style>



// WEBPACK FOOTER //
// src/ui/Menu/menuBar.vue